import { useEffect } from 'react';

export const useHandleOutsideClick = (isOpen, handler, ...refs) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    
    const onMouseDown = event => {
      const isInside = refs.some(ref => ref.current?.contains(event.target));
      
      if (!isInside) {
        handler();
      }
    };
    
    document.addEventListener('mousedown', onMouseDown);
    
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
    };
  }, [isOpen, handler, ...refs]);
};
